export default "__VITE_ASSET__DJCAjvQu__"